import React, { useEffect, useRef, useState } from 'react';
import { ArrowRight, Phone, Home } from 'lucide-react';
import LoopVideo, { filmSrc } from './loopVideo.jsx';
import ReelViewer from './reelViewer.jsx';
import { getUserProfile, listUserDesigns } from './designsApi.jsx';
import { phoneText, telHref, pushBackLayer } from './navBus.jsx';
import '../profile.scss';
import './myDesigns.scss';
import './consultantProfile.scss';

// پروفایلِ مشاور (وقتی کاربر در ریلز روی نامِ مشاور می‌زند): نام، بیوگرافی، شماره‌ی تماس (مستقیم زنگ بزند) و
// همه‌ی طرح‌هایش. owner: همان اطلاعاتِ کوتاهِ داخلِ طرح (تا قبل از رسیدنِ جواب، نام نشان داده شود)

const fa = (n) => Number(n || 0).toLocaleString('fa-IR');

function ConsultantProfile({ owner, onClose }) {
  const [profile, setProfile] = useState(null);
  const [designs, setDesigns] = useState({ items: [], loading: true, error: '' });
  const [open, setOpen] = useState(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    let cancelled = false;
    getUserProfile(owner.id)
      .then((r) => !cancelled && setProfile(r))
      .catch(() => {});
    listUserDesigns(owner.id)
      .then((r) => !cancelled && setDesigns({ items: r.items || [], loading: false, error: '' }))
      .catch((e) => !cancelled && setDesigns({ items: [], loading: false, error: e.message }));
    return () => {
      cancelled = true;
    };
  }, [owner.id]);

  // دکمه‌ی برگشتِ گوشی = بستنِ پروفایل
  useEffect(() => pushBackLayer(() => closeRef.current && closeRef.current()), []);

  const u = (profile && profile.user) || owner;
  const fullName = `${u.firstName || ''} ${u.lastName || ''}`.trim();
  const phone = u.phone || owner.phone;
  const stats = profile ? profile.stats : null;

  return (
    <div className="consultant-profile">
      <div className="profile-page">
        <header className="profile-page__header">
          <button type="button" className="consultant-profile__back" onClick={onClose} aria-label="بازگشت">
            <ArrowRight size={22} strokeWidth={1.8} />
          </button>
          <span className="profile-page__username">{fullName}</span>
          <span style={{ width: 22 }} />
        </header>

        <section className="profile-page__top">
          <div className="profile-page__avatar">
            <span>{(u.firstName || '؟').charAt(0)}</span>
          </div>
          <div className="profile-page__stats">
            <div className="profile-page__stat">
              <strong>{stats ? fa(stats.designs) : '…'}</strong>
              <span>فایل</span>
            </div>
            <div className="profile-page__stat">
              <strong>{stats ? fa(stats.views) : '…'}</strong>
              <span>بازدید</span>
            </div>
          </div>
        </section>

        <section className="profile-page__bio">
          <strong>{fullName}</strong>
          {u.role === 'consultant' && <p className="consultant-profile__role">مشاور املاک</p>}
          {(u.bio || '').split('\n').filter((l, i, a) => l || i < a.length - 1).map((line, i) => (
            <p key={i}>{line || ' '}</p>
          ))}
        </section>

        {phone && (
          <section className="consultant-profile__contact">
            <a className="consultant-profile__call" href={telHref(phone)}>
              <Phone size={18} strokeWidth={2} />
              <span>تماس با مشاور</span>
            </a>
            <a className="consultant-profile__number" href={telHref(phone)} dir="ltr">
              {phoneText(phone)}
            </a>
          </section>
        )}

        {designs.loading ? (
          <section className="profile-page__grid">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="my-designs__cell is-loading" />
            ))}
          </section>
        ) : designs.error ? (
          <p className="my-designs__empty">{designs.error}</p>
        ) : designs.items.length === 0 ? (
          <div className="my-designs__empty">
            <Home size={30} strokeWidth={1.3} />
            <p>هنوز فایلی منتشر نکرده است.</p>
          </div>
        ) : (
          <section className="profile-page__grid">
            {designs.items.map((d, i) => (
              <button key={d.id} type="button" className="my-designs__cell" onClick={() => setOpen(i)}>
                {d.filmUrl ? (
                  <LoopVideo src={filmSrc(d, true)} poster={d.thumbUrl} threshold={0.5} />
                ) : d.thumbUrl ? (
                  <img src={d.thumbUrl} alt="" loading="lazy" />
                ) : (
                  <Home size={26} strokeWidth={1.4} />
                )}
                {d.listing?.area && <span className="my-designs__badge">{fa(d.listing.area)} متر</span>}
              </button>
            ))}
          </section>
        )}
      </div>

      {open !== null && designs.items[open] && (
        // همین مشاور است — لمسِ نامش فقط ریلز را می‌بندد و به همین پروفایل برمی‌گردد
        <ReelViewer items={designs.items} startIndex={open} onClose={() => setOpen(null)} onOwner={() => setOpen(null)} layer={520} />
      )}
    </div>
  );
}

export default ConsultantProfile;
